import { AgCharts } from 'ag-charts-react'
import { useMemo } from 'react'

// AgDialChart - a dial/donut chart built with ag-charts-react
// Props:
// - height, width: dimensions in px
// - total: total value (default 100)
// - value: current filled value
// - backgroundColor: color for the remainder slice
// - highlightColor: color for the filled slice
// - innerRadius: fraction (0..1) for donut hole (default 0.9 for a thin ring)

const renderInnerLabel = (value, loading) => {
  if (loading) {
    return <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
  }
  return value + ''
}

export default function AgDialChart({
  height = 100,
  width = 100,
  max = 100,
  value = 75,
  backgroundColor = '#232426',
  highlightColor = '#05C3DD',
  loading = false,
  label = ''
}) {
  const data = useMemo(
    () => [
      { label: 'filled', value },
      { label: 'remaining', value: max - value }
    ],
    [value, max]
  )

  const palette = useMemo(
    () => [highlightColor, backgroundColor],
    [highlightColor, backgroundColor]
  )

  const options = useMemo(
    () => ({
      width,
      height,
      padding: { left: 0, right: 0, top: 0, bottom: 0 },
      data,
      series: [
        {
          type: 'donut',
          angleKey: 'value',
          fills: palette,
          cornerRadius: 10,
          sectorSpacing: 2,
          innerRadiusRatio: 0.85,
          showInLegend: false,
          strokeWidth: 0,
          innerLabels: renderInnerLabel
            ? []
            : [
                {
                  text: value + '',
                  fontSize: 18,
                  spacing: 0,
                  color: highlightColor
                }
              ],
          highlight: {
            enabled: false
          }
        }
      ],
      legend: { enabled: false },
      tooltip: { enabled: false },
      background: { fill: 'transparent' }
    }),
    [width, height, data, highlightColor, palette, value]
  )

  return (
    <div style={{ position: 'relative', width, height }}>
      <AgCharts key={label} options={options} palette={palette} />
      <div
        className="absolute top-1/2 left-1/2 font-bold text-xl"
        style={{
          color: highlightColor,
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none'
        }}>
        {renderInnerLabel(value, loading)}
      </div>
    </div>
  )
}
